/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AssignmentGradebookSubmissionGrade } from './AssignmentGradebookSubmissionGrade';
import { NormalUser } from './NormalUser';
const AssignmentGradebookRowParser = 
/* #__PURE__ */ parsers.object([
    ['user', NormalUser],
    ['grade', AssignmentGradebookSubmissionGrade],
]);
export class AssignmentGradebookRow extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentGradebookRowParser.decode(input).map(res => new AssignmentGradebookRow(res));
    }
    static unsafeDecode(input) {
        return AssignmentGradebookRow.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentGradebookRowParser.encode(data);
    }
    static schema() {
        return AssignmentGradebookRowParser.schema();
    }
}
